import { BatteryMovement } from "../layout";
import PageLayout from "./PageLayout";

const MatteryMovementPage = () => {
  return (
    <PageLayout sx={{ bgcolor: "transparent", p:"0px !important" }}>
      <BatteryMovement />
    </PageLayout>
  );
};
 
export default MatteryMovementPage;
